/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class provider_index extends IceEntity {

  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; 
  organization_name: string = "";
  first_name: string = "";
  last_name: string = "";
  sex: string = "";
  street1: string = "";
  street2: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  phone_num: string = "";
  email: string = "";
  identification_code1: string = "";
  identification_code2: string = "";
  identification_code3: string = "";
  identification_code4: string = "";
  identification_code5: string = "";
  identification_code6: string = "";
  identification_code7: string = "";
  identification_code8: string = "";
  additional_name: string = "";
  prefix: string = "";
  suffix: string = "";
  merged_trans_account: string = "";
  taxonomy_code: string = "";
  active_start_time: string = "";
  active_end_time: string = "";
  updatedisable: boolean = false;
  lastaddupdatedisablemessagekey: string = "";
  servicelevel: string = "";
  lastgetmessagekey: string = "";
  spi_num: string = "";
  dea_num: string = "";
  npi_num: string = "";
  license_num: string = "";

  constructor() {
    super();
  }

  getdisplayname(organization: boolean): string {
    if (organization)
        return this.organization_name;

    var disply = this.prefix;
    if (disply.length > 0)
        disply += " ";

    disply += this.first_name;

    if (disply.length > 0)
        disply += " " + this.last_name;

    if (this.suffix.length > 0)
        disply += ", " + this.suffix;

    return disply;
  }

  gettablename(): string {
    return "PROVIDER_INDEX";
  }
}
